import {useMemo} from "react";
import {useSelector} from "react-redux";

import {AppState, select} from "../../../store";
import {ChecklistItem} from "../../../services/ReportingService";
import {QuicksightDashboard} from "../../../services/QuicksightService";
import {getUnionWorkflowTypes} from "../../../utils/facilityWorkflowTypes";
import {useReportContext} from "../ReportContext";
import {
  getMenuDefinition,
  mapChecklistItemToMenuDefinition,
  mapDashboardsToMenuDefinition,
} from "./helpers";
import {LOADING_PLACEHOLDER} from "./ReportingWorkflowGroup";

export const useReportingMenuDefinition = (
  checklistItems: ReadonlyArray<ChecklistItem> = [],
  dashboardItems: ReadonlyArray<QuicksightDashboard> = [],
) => {
  const {activeFacilitiesIds} = useReportContext();
  const facilitiesById = useSelector((state: AppState) =>
    select.adminSession.facilitiesById(state),
  );

  return useMemo(() => {
    const scopedWorkflowTypes = getUnionWorkflowTypes(
      activeFacilitiesIds,
      facilitiesById,
    );

    const checklistMenuItems = checklistItems.filter(
      item => item.id !== LOADING_PLACEHOLDER,
    );

    return getMenuDefinition(
      mapChecklistItemToMenuDefinition(checklistMenuItems),
      mapDashboardsToMenuDefinition(dashboardItems),
      scopedWorkflowTypes,
    );
  }, [activeFacilitiesIds, checklistItems, dashboardItems, facilitiesById]);
};
